import { TabProgettoModel } from './tabProgetto.model';

export class InsertProgettoINModel {
    tabProgetto: TabProgettoModel
}